<template>
    <div class="tags-container" :class="className">
        <span
            class="tags-element"
            v-for="(value, $index) in textValues"
            :class="[{ clickable: !hasTooltip }, getClassName($index)]"
            :key="$index"
            v-tooltip="
                hasTooltip
                    ? {
                          content: value !== '...' ? value : '',
                          classes: ['adriel-tooltip', 'tags-tooltip'],
                      }
                    : false
            "
            @click="$emit('click', $index)"
        >
            <span
                class="tags-text adriel-ellipsis"
                :style="{ maxWidth: _maxWidth }"
                :contenteditable="contenteditable"
                @blur="(event) => handleContentChange(event, $index)"
                >{{ expFunc(value) }}</span
            >
            <template v-if="removable">
                <img
                    :src="deleteImgSrc"
                    v-if="deleteImgSrc"
                    @click.stop="$emit('update:remove', $index)"
                />
                <CloseIcon
                    v-if="!deleteImgSrc"
                    v-view-box
                    class="close-icon"
                    @click.stop="$emit('update:remove', $index)"
                />
            </template>
        </span>
        <slot name="input" />
    </div>
</template>

<script>
import CloseIcon from '@svgIcons/close.svg';

export default {
    props: {
        className: String,
        values: {
            type: Array,
            default() {
                return [];
            },
        },
        deleteImgSrc: {
            type: String,
        },
        hashTag: {
            type: Boolean,
            default: false,
        },
        valueGetter: {
            type: Function,
            default: R.identity,
        },
        removable: {
            type: Boolean,
            default: true,
        },
        hasTooltip: {
            type: Boolean,
            default: true,
        },
        maxCount: {
            type: [Number, String],
            default: Number.POSITIVE_INFINITY,
        },
        maxWidth: {
            type: [Number, String],
            default: 100,
        },
        contenteditable: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        CloseIcon,
    },
    computed: {
        _values() {
            return R.compose(R.take(this.maxCount), R.prop('values'))(this);
        },
        textValues() {
            var ret = R.compose(
                R.map(this.valueGetter),
                R.prop('_values')
            )(this);

            if (this.values.length !== ret.length) {
                ret.push('...');
            }

            return ret;
        },
        _maxWidth() {
            const { maxWidth, windowDimension } = this;

            if (windowDimension.width <= 767) {
                return '100%';
            } else {
                if (String(maxWidth).endsWith('%')) {
                    return maxWidth;
                } else {
                    return `${maxWidth}px`;
                }
            }
        },
        expFunc() {
            return this.hashTag ? R.concat('# ') : R.identity;
        },
    },
    methods: {
        isActive(value, index) {
            return !(this.textValues.length - 1 === index && value === '...');
        },
        handleContentChange(e, index) {
            if (!this.contenteditable) {
                return;
            }

            this.$emit('update:content', {
                value: e.target.textContent,
                index,
            });
        },
        getClassName(index) {
            return R.pathOr('', ['_values', index, 'className'], this);
        },
    },
};
</script>

<style lang="scss" scoped>
.tags-container {
    margin: -2.5px -3.5px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .close-icon {
        fill: white;
        width: 12px;
        height: 12px;
        cursor: pointer;
    }
}

.tags-element {
    &.clickable {
        cursor: pointer;
    }
    margin: 2.5px 3.5px;
    color: $color1;
    background-color: $color29;
    height: 25px;
    padding: 0 10px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    font-size: 12px;

    img {
        margin-left: 5px;
        cursor: pointer;
    }

    &:last-child {
        margin-right: 0;
    }

    .tags-text {
        height: 100%;
        line-height: 25px;
        display: flex;
        align-items: center;

        &[contenteditable='true'] {
            &:hover,
            &:active,
            &:focus {
                border: none;
                outline: none;
                text-decoration: underline;
            }
        }
    }
}
</style>
